import { requests } from '../index';
import URLS  from '../endPoints';


let Auth = {}

Auth.login = (encryptedUserID) => requests.get('/recruiter/login?emailId=' + encryptedUserID)

Auth.Magittlogin = async (payload) => await requests.Textpost('login', payload)
Auth.Magittsignup = async (payload) => await requests.post('signup', payload)
Auth.MagittcreateNewUser = async (payload) => await requests.post('createNewUser', payload)
Auth.Magittregistration = async (payload) => await requests.post('registration', payload)
Auth.SaveCandidateId = async (payload) => await requests.post('SaveCandidateId', payload)

Auth.Hclogin = async (payload) => await requests.postHC('Career/Login', payload)
// magitt token api call
Auth.getTokenMagitt = async () => await requests.postToken(URLS.magUrl.token, {userId:process.env.REACT_APP_MG_TOKEN_USER,password:process.env.REACT_APP_MG_TOKEN_PASSWORD}) //api call

//hc Token api call
Auth.getToken = () => requests.postHC(URLS.hcUrl.token, "grant_type=password&UserName="+process.env.REACT_APP_HC_TOKEN_USER+"&Password="+process.env.REACT_APP_HC_TOKEN_PASSWORD+"")

Auth.Whatsapp = (payload) => requests.postHC(URLS.hcUrl.whatsappconsent,payload)

export default Auth;
